class BundleBlock extends HTMLElement {
    constructor() {
        super();

        this.packIcons = this.querySelectorAll('.bundle-pack-element-icon');
        this.bundleATC = this.querySelector('.js-bundle-item-add');
        this.packIcons.forEach((packIcon) => {
            packIcon.addEventListener('click', this.packIconChange.bind(this))
        });
        this.selectOption = this.querySelector('select');
        this.bundleAddtoCart = this.querySelector('.js-bundle-atc');

        this.selectOption.addEventListener('change', this.selectOptionChange.bind(this));
        this.bundleATC.addEventListener('click', this.bundleOptionClick.bind(this));
        this.bundleAddtoCart.addEventListener('click', this.bpCheckout.bind(this));
    }

    formatMoney(cents, format = "{{amount}}") {
        let value = (cents / 100).toFixed(2); // Convert to dollars
        let formatted = value;

        if (format === "{{amount_no_decimals}}") {
            formatted = Math.round(cents / 100).toString();
        } else if (format === "{{amount_with_comma_separator}}") {
            formatted = value.replace(/\./, ',');
        } else if (format === "{{amount_no_decimals_with_comma_separator}}") {
            formatted = Math.round(cents / 100).toString().replace(/\./, ',');
        } else if (format === "{{amount_with_apostrophe_separator}}") {
            formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, "'"); // 1'234.56
        } else {
            formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 1,234.56
        }

        return formatted;
    }

    bpCheckout(){
        let items = [];
        const addedItems = this.querySelectorAll('.bundle-pack-cell-content');

        addedItems.forEach((addedItem) => {
            const vid = parseInt(addedItem.getAttribute('data-variantid'));

            items.push({'id': vid, 'quantity': 1});
        });

        fetch(`${window.Shopify.routes.root}` + 'cart/clear.js', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        }).then(response => {
            let formData = {
                'items': items
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });
    }

    bundleOptionClick(event){
        const selection = event.target;
        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();
        
        if(currentProduct && currentVariant){
            const cellItems = this.querySelectorAll('.bundle-pack-cell');
            let itemAdded = false;

            cellItems.forEach((cellItem, index) => {
                const selectedItem = cellItem.querySelector('.bundle-pack-cell-content');

                if(!selectedItem && !itemAdded){
                    const imprtContet = document.createElement('div');
                    const imprtImg = `<img src="${currentProduct.featured_image}&width=100" width="100" height="100" alt="${currentProduct.title}">`;
                    const imprtButtonClose = document.createElement('div');
                    const nextIndex = index + 1;

                    imprtContet.classList.add('bundle-pack-cell-content');
                    imprtContet.setAttribute('data-index', nextIndex);
                    imprtContet.setAttribute('data-productid', currentProduct.id);
                    imprtContet.setAttribute('data-variantid', currentVariant.id);
                    imprtButtonClose.classList.add('bundle-pack-cell-close', 'js-bundle-pack-close');
                    imprtButtonClose.insertAdjacentHTML('beforeend', `<svg class="icon icon-close icon-sm" viewBox="0 0 20 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15L15 5M5 5L15 15"></path>
                                        </svg>`);
                    imprtContet.insertAdjacentHTML('beforeend', imprtImg);
                    imprtContet.insertAdjacentElement('beforeend', imprtButtonClose);
                    imprtButtonClose.addEventListener('click', (e) => {
                        const btarget = e.target;
                        const bBlock = btarget.closest('.bundle-pack-cell-content');

                        if(bBlock){
                            bBlock.remove();
                        }
                        this.updatePrices();
                    })

                    cellItem.insertAdjacentElement('beforeend', imprtContet);
                    itemAdded = true;
                }
            });

            this.updatePrices();
        }
    }

    selectOptionChange(event){
        const selection = event.target;
        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();
        
        if(currentVariant.available){
            this.bundleATC.removeAttribute('disabled');
            this.bundleATC.innerText = 'Add to Bundle';
        }else{
            this.bundleATC.setAttribute('disabled', 'disabled');
            this.bundleATC.innerText = 'Out of Stock';
        }
        this.updatePackSelectedItem(currentVariant, currentProduct);
    }

    packIconChange(event){
        const selection = event.target;
        const selectedPackIcon = selection.classList.contains('bundle-pack-element-icon')?selection:selection.closest('.bundle-pack-element-icon');
        const selectionProductId = selectedPackIcon.getAttribute('data-productid');
        const bundPackProductPrice = this.querySelector('.bundle-pack-product-price');
        const bundPackProductComparePrice = this.querySelector('.bundle-pack-product-compare-price');

        this.packIcons.forEach((packIcon) => {
            packIcon.classList.remove('active');
        });
        selectedPackIcon.classList.add('active');

        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();

        if(currentVariant.available){
            this.bundleATC.removeAttribute('disabled');
            this.bundleATC.innerText = 'Add to Bundle';
        }else{
            this.bundleATC.setAttribute('disabled', 'disabled');
            this.bundleATC.innerText = 'Out of Stock';
        }        
        if(currentProduct && currentVariant){
            this.updatePackSelectedItem(currentVariant, currentProduct);
        }

    }

    updatePackSelectedItem(currentVariant, currentProduct){
        const imgWrap = this.querySelector('.bundle-pack-product-image');
        const titleWrap = this.querySelector('.bundle-pack-product-title');
        const priceWrap = this.querySelector('.bundle-pack-product-prices');
        let featuredImage = currentProduct.featured_image;
        const imgHtml = `<img src="${featuredImage}&width=200" alt="${currentProduct.title}" 
                             srcset="${featuredImage}&width=120 120w, ${featuredImage}&width=150 150w, ${featuredImage}&width=175 175w, ${featuredImage}&width=200 200w" width="200" height="200">`;
        const priceHTML = `<div class="bundle-pack-product-compare-price">$${this.formatMoney(currentVariant.price, "{{amount}}")}</div>
                            <div class="bundle-pack-product-price">$${this.formatMoney(this.getDiscountedPrice(currentVariant.price), "{{amount}}")}</div>`;
        
        imgWrap.innerHTML = imgHtml;
        titleWrap.innerText = currentProduct.title;
        priceWrap.innerHTML = priceHTML;
    }

    updatePrices(){
        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();
        const selectedItems = this.querySelectorAll('.bundle-pack-cell-content');
        const selectedBundleQty = parseInt(selectedItems.length) + 1;
        const bundPackProductPrice = this.querySelector('.bundle-pack-product-price');
        const bundPackProductComparePrice = this.querySelector('.bundle-pack-product-compare-price');
        let totalPrice = 0;
        if(selectedBundleQty > 6) return false;
        const preselectedBundleDiscount = bundleBlockSize.find((bundlePackSizeItem) => bundlePackSizeItem.count == parseInt(selectedItems.length)).discount;
        const selectedBundleDiscount = bundleBlockSize.find((bundlePackSizeItem) => bundlePackSizeItem.count == selectedBundleQty).discount;
        const bundleblockAtc = this.querySelector('.js-bundle-atc');

        selectedItems.forEach((selectedItem) => {
            const productId = selectedItem.getAttribute('data-productid');
            const variantId = selectedItem.getAttribute('data-variantid');
            const selectedProduct = products.find((product) => product.id == parseInt(productId));
            const selectedVariant = selectedProduct.variants.find((variant) => variant.id == parseInt(variantId));

            totalPrice = totalPrice + selectedVariant.price;
        });

        const salePrice = totalPrice * preselectedBundleDiscount / 100;
        
        if(bundPackProductPrice && bundPackProductComparePrice){
            bundPackProductPrice.innerHTML = `$${this.formatMoney(this.getDiscountedPrice(currentVariant.price), "{{amount}}")}`;
            bundPackProductComparePrice.innerHTML = `$${this.formatMoney(currentVariant.price, "{{amount}}")}`;
        }

        if(selectedBundleQty> 2){
            const buttonAtcContent = `<span class="bundle-atc-text">Buy Bundle Pack ${parseInt(selectedItems.length)}</span>
                                      <span class="bundle-atc-price"> - $${this.formatMoney(salePrice, "{{amount}}")}</span>
                                      <span class="bundle-atc-cross-price"> $${this.formatMoney(totalPrice, "{{amount}}")}</span>`;

            bundleblockAtc.removeAttribute('disabled');
            bundleblockAtc.innerHTML = buttonAtcContent;
        }else{
            bundleblockAtc.setAttribute('disabled', 'disabled');
            bundleblockAtc.innerHTML = `<span class="bundle-atc-text">Add More Products!</span>`;
        }
    }

    getDiscountedPrice(price){
        const selectedItems = this.querySelectorAll('.bundle-pack-cell-content');
        const selectedBundleQty = parseInt(selectedItems.length) + 1;
        if(selectedBundleQty > 6) return false;
        const selectedBundleDiscount = bundleBlockSize.find((bundlePackSizeItem) => bundlePackSizeItem.count == selectedBundleQty).discount;
        
        return price * selectedBundleDiscount / 100;
    }

    getSelectedProduct(){
        const selectedProductID = this.querySelector('.bundle-pack-element-icon.active').getAttribute('data-productid');
        const selectedProduct = products.find((product) => product.id == parseInt(selectedProductID));

        if(!selectedProduct) return false;

        return selectedProduct;
    }

    getSelectedVariant(){
        this.selectedoptions = Array.from(this.querySelectorAll('select.option'), (select) => select.value);

        if(this.getSelectedProduct()){
            this.selectedVariant = this.getSelectedProduct().variants.find((variant) => {
                return !variant.options.map((option, index) => {
                    return this.selectedoptions[index] === option;
                }).includes(false);
            });

            if(!this.selectedVariant) return false;

            return this.selectedVariant;
        }else{
            return false;
        }
    }
}

customElements.define('bundle-block', BundleBlock);